module.exports = __webpack_public_path__ + "6db4c582af9762688693df98313d7455.svg";